module.exports = __webpack_public_path__ + "img/RomaniaSmall.2b512abe.png";